import { InjectedConnector } from '@web3-react/injected-connector';
import { REACT_APP_CHAIN_ID } from '../constants/envs';

export const Injected = new InjectedConnector({
  supportedChainIds: [Number(REACT_APP_CHAIN_ID)],
});
